import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { isString, once } from 'lodash-es';
import Cookies from 'js-cookie';
import isNumeric from 'validator/lib/isNumeric';
import { CookieKey, HttpStatusCode } from '~/core/enums';
import { AnalyticsApi, AuthApi } from '~/core/api';
import { isAppSupported, isDeeplinkOnlyPage, sendOpenMtAnalytics } from '~/core/functions';
import { useAppLink } from '~/core/composables';
import { ReservedQueryKey } from '~/core/enums/routing';
import { ymUserParams } from '~/core/utils/yandexReachGoal';
import { SessionStorageKey } from '~/core/enums/sessionStorageKey';
import { buildNextQuery, isTrustedUrl } from '~/core/functions/url';
import { DEEPLINK_ONLY_PAGES_NAMES } from '~/core/constants/deeplinkOnlyPagesNames';
import useMainStore from '~/stores/useMainStore';
import useProfileStore from '~/stores/useProfileStore';
import showError from '~/bridge/showError';
import { AgreementStatus } from '~/features/Profile/enums';
import { NotificationsApi } from '~/features/Notifications/api';
import { CLINIC_HASH_SESSION_STORAGE_KEY, CLINIC_SOURCE_SESSION_STORAGE_KEY } from '~/features/Clinics/constants';
import { REDIRECT_TO_MEDCARD_WITH_DOCUMENT_MIS } from '~/features/Appointments/constants/sessionStorage';
import { OAUTH_PAGES_NAMES } from '~/features/Authorization/constant/settings';
import { resolveMasterPasswordForbidden } from '~/features/MasterPassword/functions/resolveMasterPasswordForbidden';
var APP_ENTRY_QUERY_KEYS = [ReservedQueryKey.OpenApp, ReservedQueryKey.AppWbAuth, ReservedQueryKey.AppOauthProvider];
var setYmUserParams = once(ymUserParams);
var resetYmUserParamsFunction = function resetYmUserParamsFunction() {
  setYmUserParams = once(ymUserParams);
};
var readNotification = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to) {
    var _useNuxtApp, $captureException, _to$query, id, key, payload;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _useNuxtApp = useNuxtApp(), $captureException = _useNuxtApp.$captureException;
          _context.prev = 1;
          _to$query = to.query, id = _to$query[ReservedQueryKey.NotificationId], key = _to$query[ReservedQueryKey.IdempotencyKey];
          if (!(!id && !key)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          payload = {
            notificationId: isString(id) ? Number(id) : undefined,
            idempotencyKey: !id && isString(key) ? key : undefined
          };
          _context.next = 8;
          return NotificationsApi.markAsRead(payload);
        case 8:
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
          $captureException(_context.t0, {
            method: 'readNotification',
            component: 'pluginAuth'
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  }));
  return function readNotification(_x) {
    return _ref.apply(this, arguments);
  };
}();
var sendReferralId = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
    var _useNuxtApp2, $captureException, _e$response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _useNuxtApp2 = useNuxtApp(), $captureException = _useNuxtApp2.$captureException;
          if (!(!isString(id) || !isNumeric(id))) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          _context2.prev = 3;
          _context2.next = 6;
          return AnalyticsApi.sendReferralId(Number(id));
        case 6:
          _context2.next = 11;
          break;
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](3);
          if (((_e$response = _context2.t0.response) === null || _e$response === void 0 ? void 0 : _e$response.status) !== HttpStatusCode.NotFound) {
            $captureException(_context2.t0, {
              method: 'sendReferralId',
              component: 'pluginAuth'
            });
          }
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 8]]);
  }));
  return function sendReferralId(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var isTokenWasCleared = function isTokenWasCleared(from, to) {
  // Условие выполняется после удаления токена авторизации (token) из query
  return from.path === to.path && from.query.token && !to.query.token;
};
var clearQuery = function clearQuery(to) {
  var queryToClear = [];
  Object.values(ReservedQueryKey).forEach(function (key) {
    if (to.query[key]) {
      queryToClear.push(key);
    }
  });
  if (queryToClear.length) {
    return navigateTo({
      path: to.path,
      query: _objectSpread(_objectSpread({}, to.query), queryToClear.reduce(function (res, param) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, param, undefined));
      }, {}))
    });
  }
};
export default defineNuxtRouteMiddleware(/*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(to, from) {
    var _to$meta, _to$name;
    var _useNuxtApp3, $captureException, $device, $sentry, $featureFlag, mainStore, profileStore, meta, _useAppLink, deepLink, me, requestError, requestedNext, next, _me$data, _me$data$phone, phone, _me$data$townName, townName, _me$data$townKey, townKey, _me$data$townId, townId, _me$data$townConfirme, townConfirmed, _me$data$rulesAgreeme, rulesAgreementStatus, _me$data$unreadNotifi, unreadNotificationsCount, _me$data$medcardActiv, medcardActiveSessionsCount, _me$data$id, id, _me$data$country, country, toClearedQuery, response, message, masterPasswordGuardRedirect, query;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _useNuxtApp3 = useNuxtApp(), $captureException = _useNuxtApp3.$captureException, $device = _useNuxtApp3.$device, $sentry = _useNuxtApp3.$sentry, $featureFlag = _useNuxtApp3.$featureFlag;
          mainStore = useMainStore();
          profileStore = useProfileStore();
          meta = ((_to$meta = to.meta) === null || _to$meta === void 0 ? void 0 : _to$meta[0]) || {}; // NOTE: Используется для отключения авторизации для определенных роутов
          if (!(meta.disableAuth || (_to$name = to.name) !== null && _to$name !== void 0 && _to$name.includes('dental-articles') || to.name === 'to-next')) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return");
        case 6:
          if (!isTokenWasCleared(from, to)) {
            _context3.next = 8;
            break;
          }
          return _context3.abrupt("return");
        case 8:
          _context3.prev = 8;
          if (!isDeeplinkOnlyPage(to, $device, $sentry)) {
            _context3.next = 11;
            break;
          }
          return _context3.abrupt("return");
        case 11:
          if (!OAUTH_PAGES_NAMES.includes(to.name)) {
            _context3.next = 13;
            break;
          }
          return _context3.abrupt("return");
        case 13:
          if (APP_ENTRY_QUERY_KEYS.some(function (key) {
            return to.query[key];
          }) && $device.isMobileOrTablet && isAppSupported({
            $device: $device,
            $sentry: $sentry
          })) {
            _useAppLink = useAppLink(to), deepLink = _useAppLink.deepLink;
            location.href = deepLink.value;
          }
          if (!(to.name === 'appointments-id-payment-wait')) {
            _context3.next = 23;
            break;
          }
          _context3.t0 = isString(to.query.next);
          if (!_context3.t0) {
            _context3.next = 20;
            break;
          }
          _context3.next = 19;
          return isTrustedUrl(to.query.next);
        case 19:
          _context3.t0 = _context3.sent;
        case 20:
          if (!_context3.t0) {
            _context3.next = 22;
            break;
          }
          return _context3.abrupt("return", navigateTo(to.query.next, {
            external: true,
            replace: true
          }));
        case 22:
          return _context3.abrupt("return", navigateTo('/'));
        case 23:
          _context3.prev = 23;
          _context3.next = 26;
          return AuthApi.get(to.query[ReservedQueryKey.Token]);
        case 26:
          me = _context3.sent;
          _context3.next = 32;
          break;
        case 29:
          _context3.prev = 29;
          _context3.t1 = _context3["catch"](23);
          requestError = _context3.t1;
        case 32:
          if (me) {
            _context3.next = 34;
            break;
          }
          throw requestError;
        case 34:
          if (!(to.name === 'authorization')) {
            _context3.next = 43;
            break;
          }
          _context3.t2 = isString(to.query.next);
          if (!_context3.t2) {
            _context3.next = 40;
            break;
          }
          _context3.next = 39;
          return isTrustedUrl(to.query.next);
        case 39:
          _context3.t2 = _context3.sent;
        case 40:
          if (!_context3.t2) {
            _context3.next = 42;
            break;
          }
          return _context3.abrupt("return", navigateTo(to.query.next, {
            external: true,
            replace: true
          }));
        case 42:
          return _context3.abrupt("return", navigateTo('/'));
        case 43:
          if (!($featureFlag('wff_master_password') && to.name === 'master-password')) {
            _context3.next = 47;
            break;
          }
          requestedNext = to.query.next;
          next = isString(requestedNext) && requestedNext.startsWith('/') ? requestedNext : '/';
          return _context3.abrupt("return", navigateTo(next, {
            replace: true
          }));
        case 47:
          if (!(to.name && DEEPLINK_ONLY_PAGES_NAMES.includes(to.name))) {
            _context3.next = 49;
            break;
          }
          return _context3.abrupt("return", navigateTo('/'));
        case 49:
          _me$data = me.data, _me$data$phone = _me$data.phone, phone = _me$data$phone === void 0 ? '' : _me$data$phone, _me$data$townName = _me$data.townName, townName = _me$data$townName === void 0 ? '' : _me$data$townName, _me$data$townKey = _me$data.townKey, townKey = _me$data$townKey === void 0 ? '' : _me$data$townKey, _me$data$townId = _me$data.townId, townId = _me$data$townId === void 0 ? -1 : _me$data$townId, _me$data$townConfirme = _me$data.townConfirmed, townConfirmed = _me$data$townConfirme === void 0 ? false : _me$data$townConfirme, _me$data$rulesAgreeme = _me$data.rulesAgreementStatus, rulesAgreementStatus = _me$data$rulesAgreeme === void 0 ? AgreementStatus.Default : _me$data$rulesAgreeme, _me$data$unreadNotifi = _me$data.unreadNotificationsCount, unreadNotificationsCount = _me$data$unreadNotifi === void 0 ? 0 : _me$data$unreadNotifi, _me$data$medcardActiv = _me$data.medcardActiveSessionsCount, medcardActiveSessionsCount = _me$data$medcardActiv === void 0 ? 0 : _me$data$medcardActiv, _me$data$id = _me$data.id, id = _me$data$id === void 0 ? undefined : _me$data$id, _me$data$country = _me$data.country, country = _me$data$country === void 0 ? null : _me$data$country;
          profileStore.phone = phone;
          profileStore.setTown({
            town: townName,
            townKey: townKey,
            townId: townId
          });
          profileStore.townConfirmed = townConfirmed;
          profileStore.agreementStatus = rulesAgreementStatus;
          profileStore.unreadNotificationsCount = unreadNotificationsCount;
          profileStore.medcardActiveSessionsCount = medcardActiveSessionsCount;
          profileStore.country = country;
          mainStore.fetchSpecialities();
          setYmUserParams({
            UserID: id,
            ReferralDoctorID: to.query[ReservedQueryKey.ReferralDoctorId]
          });
          if (to.query[ReservedQueryKey.MedcardToken]) {
            Cookies.set(CookieKey.MedcardToken, to.query[ReservedQueryKey.MedcardToken], {
              expires: 14
            });
          }
          readNotification(to);
          if (to.query[ReservedQueryKey.ReferralDoctorId]) {
            sendReferralId(to.query[ReservedQueryKey.ReferralDoctorId]);
          }
          if (to.query[ReservedQueryKey.LpuHash]) {
            sessionStorage.setItem(CLINIC_HASH_SESSION_STORAGE_KEY, to.query[ReservedQueryKey.LpuHash].toString());
          }
          if (to.query[ReservedQueryKey.LpuSource]) {
            sessionStorage.setItem(CLINIC_SOURCE_SESSION_STORAGE_KEY, to.query[ReservedQueryKey.LpuSource].toString());
          }
          if (to.query[ReservedQueryKey.IsEsiaTransferSuccess]) {
            sessionStorage.setItem(SessionStorageKey.IsEsiaTransferSuccess, to.query[ReservedQueryKey.IsEsiaTransferSuccess].toString());
          }
          if (to.query[ReservedQueryKey.OpenMainFamilyProfile]) {
            sessionStorage.setItem(SessionStorageKey.OpenMainFamilyProfile, to.query[ReservedQueryKey.OpenMainFamilyProfile].toString().toLowerCase());
          }
          if (to.query[ReservedQueryKey.RequireEsia]) {
            sessionStorage.setItem(SessionStorageKey.RequireEsia, to.query[ReservedQueryKey.RequireEsia].toString().toLowerCase());
          }
          if (to.query[ReservedQueryKey.EsiaAction]) {
            sessionStorage.setItem(SessionStorageKey.EsiaAction, to.query[ReservedQueryKey.EsiaAction].toString().toLowerCase());
          }
          _context3.next = 70;
          return sendOpenMtAnalytics($captureException);
        case 70:
          toClearedQuery = clearQuery(to);
          if (!toClearedQuery) {
            _context3.next = 73;
            break;
          }
          return _context3.abrupt("return", toClearedQuery);
        case 73:
          // NOTE: редирект с главной на медкарту нужно делать только когда пользователь сразу зашел
          // на главную (или после авторизации). И не делать когда он перешел на главную с других страниц
          if ((from.name === 'index' || from.name === 'authorization') && sessionStorage.getItem(REDIRECT_TO_MEDCARD_WITH_DOCUMENT_MIS) !== 'false') {
            sessionStorage.setItem(REDIRECT_TO_MEDCARD_WITH_DOCUMENT_MIS, 'true');
          } else if (sessionStorage.getItem(REDIRECT_TO_MEDCARD_WITH_DOCUMENT_MIS) !== 'true') {
            sessionStorage.setItem(REDIRECT_TO_MEDCARD_WITH_DOCUMENT_MIS, 'false');
          }
          _context3.next = 96;
          break;
        case 76:
          _context3.prev = 76;
          _context3.t3 = _context3["catch"](8);
          response = _context3.t3.response;
          message = _context3.t3.message;
          resetYmUserParamsFunction();
          _context3.next = 83;
          return resolveMasterPasswordForbidden(to, response);
        case 83:
          masterPasswordGuardRedirect = _context3.sent;
          if (!((masterPasswordGuardRedirect === null || masterPasswordGuardRedirect === void 0 ? void 0 : masterPasswordGuardRedirect.path) === to.fullPath)) {
            _context3.next = 86;
            break;
          }
          return _context3.abrupt("return");
        case 86:
          if (!masterPasswordGuardRedirect) {
            _context3.next = 88;
            break;
          }
          return _context3.abrupt("return", navigateTo(masterPasswordGuardRedirect.path, {
            external: masterPasswordGuardRedirect.external,
            replace: masterPasswordGuardRedirect.replace
          }));
        case 88:
          if (!(to.name === 'authorization' && (response === null || response === void 0 ? void 0 : response.status) === 401)) {
            _context3.next = 91;
            break;
          }
          Cookies.remove(CookieKey.MedcardToken);
          return _context3.abrupt("return");
        case 91:
          if (!((response === null || response === void 0 ? void 0 : response.status) === 401)) {
            _context3.next = 95;
            break;
          }
          Cookies.remove(CookieKey.MedcardToken);
          query = buildNextQuery(to.fullPath, to.query[ReservedQueryKey.PreselectedCountry]);
          return _context3.abrupt("return", navigateTo("/authorization/".concat(query)));
        case 95:
          showError({
            statusCode: response === null || response === void 0 ? void 0 : response.status,
            message: message
          });
        case 96:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[8, 76], [23, 29]]);
  }));
  return function (_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}());